import React from 'react';
import moment from 'moment';
import {fromJS, Map} from 'immutable';

import {getStoreByName} from 'client/framework';
import LoadingIndicator from 'generic/LoadingIndicator.react';
import ScopeSelector, {
  selectorComponentNames
} from 'client/generic/ScopeSelector/ScopeSelector.react';
import StudentTopics from 'client/Student/Topics/Topics.react';
import {getBaseUserQuery} from 'client/User/UserQueryUtil';
import sessionStore from 'client/Session/SessionStore';
import {requireSession} from 'lib/decorators/requireSession';

import studentDetailUtil from './StudentDetail.util';

import './student-detail.scss';

@requireSession()
class StudentDetail extends React.Component {
  constructor() {
    super();
    this.selectorStoreName = 'studentDetailScopeSelector';
  }

  getQueryParameters() {
    const selectorStore = getStoreByName(this.selectorStoreName);

    if (!selectorStore) {
      return null;
    }

    const selectedSubject = selectorStore
      .getStoreForSelector(selectorComponentNames.subjectSelector)
      .getSelectedItem();

    const selectedAttemptNumber = selectorStore
      .getStoreForSelector(selectorComponentNames.attemptSelector)
      .getSelectedItem()
      .get('value');

    const selectedStartDate = moment(
      selectorStore.getStoreForSelector(selectorComponentNames.dateRangeSelector).getStartDate()
    )
      .startOf('day')
      .valueOf();

    const selectedEndDate = moment(
      selectorStore.getStoreForSelector(selectorComponentNames.dateRangeSelector).getEndDate()
    )
      .endOf('day')
      .valueOf();

    return {
      attemptNumber: selectedAttemptNumber,
      endDate: selectedEndDate,
      selectedSubject: selectedSubject.getId(),
      studentId: studentDetailUtil.getStudentId(),
      startDate: selectedStartDate
    };
  }

  getSelectorComponentOptions() {
    return new Map({
      [selectorComponentNames.subjectSelector]: studentDetailUtil.getSubjects(),
      [selectorComponentNames.attemptSelector]: fromJS([
        {
          id: 'most-recent',
          name: 'Most Recent',
          value: null
        },
        {
          id: 1,
          name: 1,
          value: 1
        },
        {
          id: 2,
          name: 2,
          value: 2
        },
        {
          id: 3,
          name: 3,
          value: 3
        }
      ])
    });
  }

  render() {
    if (!process.env.IS_BROWSER) {
      return null;
    }

    if (!studentDetailUtil.areSubjectsReady()) {
      return <LoadingIndicator />;
    }

    const displayName = getBaseUserQuery(sessionStore.getUserId()).getResource().getDisplayName();

    return (
      <div className='student-detail'>
        <h2 className='student-detail-header'>{displayName}</h2>
        <ScopeSelector
          className='card'
          destroyStoreOnUnmount
          defaultSubjectId={studentDetailUtil.getDefaultSubjectId()}
          defaultStartDate={studentDetailUtil.getDefaultStartDate()}
          defaultEndDate={studentDetailUtil.getDefaultEndDate()}
          includedSelectors={studentDetailUtil.getSelectorComponents()}
          selectorComponentOptions={this.getSelectorComponentOptions()}
          selectorStoreName='studentDetailScopeSelector'
        />
        <StudentTopics scopeParameters={this.getQueryParameters()} />
      </div>
    );
  }
}

export default StudentDetail;
